<template>
  <div class="navigation-container">
    <div
      class="list-item"
      v-for="(item, index) in pathList"
      :key="index"
    >
      <span v-if="index !== 0" class="interval-icon">/</span>
      <span :class="['path-name', item.current && 'current']" @click="handelClick(item)">{{ $t(item.i18nName) }}</span>
    </div>
  </div>
</template>

<script>
import { getIncludeRoutePath } from '@/router/routes'

export default {
  props: {
    pathList: {
      required: true
    }
  },
  components: {
  },
  data () {
    return {}
  },
  computed: {
  },
  created () {

  },
  methods: {
    handelClick (item) {
      if (item.current || !item.path) {
        return
      }
      const path = getIncludeRoutePath(item.path)
      if (path) {
        return this.$router.push({ path: path, query: this.$route.query })
      } else {
        window.location.href = item.path
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.navigation-container {
  display: flex;
  margin-bottom: 20px;
  font-size: 18px;
  line-height: 25px;

  .list-item {
    color: #909399;
    .interval-icon {
      margin: 0 10px;
    }

    .path-name {
      color: #0096CC;
      cursor: pointer;

      &.current {
        cursor: default;
        color: #909399;
      }
    }
  }

}
</style>
